import Image from 'next/image';
import Link from 'next/link';
import { logEvent } from '../lib/analytics';
import { entryToLink, RichText } from '../lib/copyRendering';
import { Button } from './Button';
import { Column, Row, Section } from './Section';
import { Text } from './Text';
import { WhySectionFragment } from './WhySection.generated';

interface WhySectionProps {
  snippetGroup: WhySectionFragment | undefined;
  analyticsPageName: 'Home' | 'Medicare';
}

export const WhySection: React.FC<WhySectionProps> = ({
  snippetGroup,
  analyticsPageName,
}) => (
  <Section>
    <Row>
      <Column>
        <Text.H2 className="text-center !mb-2">{snippetGroup?.name}</Text.H2>
        <Text.Body className="text-center !text-gray-500 !text-2xl !font-medium">
          {snippetGroup?.subtitle}
        </Text.Body>
      </Column>
    </Row>
    <Row>
      <Column>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-10">
          {snippetGroup?.snippetsCollection?.items.map((snippet) =>
            snippet?.__typename === 'Snippet' && snippet.content ? (
              <div className="flex flex-col items-start" key={snippet.key}>
                <Image
                  src={snippet.image?.url ?? ''}
                  width={snippet.image?.width ?? undefined}
                  height={snippet.image?.height ?? undefined}
                  className="mb-3 self-center"
                  alt={snippet.image?.description ?? ''}
                />
                <Text.H3 className="!text-base md:!text-lg !font-medium">
                  {snippet.name}
                </Text.H3>
                <RichText content={snippet.content} />
                {snippet.link && snippet.linkLabel && (
                  <div className="self-stretch flex-1 flex justify-center items-end">
                    <Button
                      variant="PRIMARY"
                      is={Link}
                      href={entryToLink(snippet.link)}
                      className="sm:px-8"
                      analytics={{
                        category: analyticsPageName,
                        name: 'Why Section',
                        buttonLabel: snippet.linkLabel,
                        link: entryToLink(snippet.link),
                      }}
                    >
                      {snippet.linkLabel}
                    </Button>
                  </div>
                )}
              </div>
            ) : null,
          )}
        </div>
      </Column>
    </Row>
  </Section>
);
